import { LeagueTableView } from '../../../components';
import { User } from '../../../../models';
import EmptyLeagueRowView from '../LadderEmpty';
import Radio from 'backbone.radio';
import CoreOverallLadder from '../../../../collections/OverallLadder';
import { Preloader } from '../../../../utils';

const leagueLadderChannel = Radio.channel('league_ladder');
const globalChannel = Radio.channel( 'global' );

/**
 * @desc Core League CoreLeagueLadderView View Class
 */
export class CoreLeagueLadderView extends LeagueTableView {
	get emptyView() {
		return EmptyLeagueRowView;
	}

	get childView() {
		throw new Error("Need set childView for child CoreLeagueLadderView class");
	}

	get className() {
		return "league-ladder-page shadow";
	}

	get childViewOptions() {
		return {
			template_type: this.model.get( 'template_type' ),
			actual_round:  this.actual_round,
			league:        this.model
		};
	}

	get default_offset() {
		return 100;
	}

	get default_limit() {
		return 100;
	}

	/**
	 *    Initialize view data
	 */
	async initialize() {
		// this.liveScoresIntervalId = null;

		this.regeneration          = this.getOption( 'regeneration' );
		this.user                  = User;
		this.limit                 = this.default_limit;
		this.historical_collection = [];
		this.offset                = 0;
		this.league_id             = this.getOption( 'league_id' );
		this.overallLadder         = this.getOption( 'overallLadder' );
		this.leagueTeams           = this.getOption( 'leagueTeams' );
		this.rounds                = this.getOption( 'rounds' );
		this.actual_round          = 0;
		this.selected_round        = 0;
		this.collection            = new CoreOverallLadder();

		await this.fetchData();
		this.initListeners()
			.updateModel()
			.updatePageData();
	}

	initListeners() {
		this.listenTo( leagueLadderChannel, 'ladder:switch:table', this.switchTable );
		this.listenTo( leagueLadderChannel, 'ladder:update', this.updatePageData );
		// this.listenTo( leagueLadderChannel, 'ladder:update', this.initLiveScores );
		this.listenTo( leagueLadderChannel, 'ladder:update:round', this.updatePageDataRound );
		this.listenTo( globalChannel, 'click:load:more', this.showMore );
		return this;
	}

	// initLiveScores() {
	// 	this.current_round = this.rounds.points_round;
	//
	// 	if(this.current_round.get('status') === 'active'){
	// 		this.subscribeToLiveUpdates();
	// 	}
	// 	else {
	// 		clearInterval(this.liveScoresIntervalId);
	// 	}
	//
	// 	return this;
	// }
	//
	// subscribeToLiveUpdates() {
	// 	if(this.liveScoresIntervalId){
	// 		return this;
	// 	}
	//
	// 	const updateInterval = 1000 * 60 * 5;
	// 	this.liveScoresIntervalId = setInterval(() => this.liveUpdates(), updateInterval);
	// }
	//
	// liveUpdates() {
	// 	this.fetchData().then(() => {
	// 		this.updateModel()
	// 			.initLiveScores()
	// 			.updatePageData();
	// 	});
	//
	// 	return this;
	// }

	updateCollection() {
		this.actual_round = this.rounds.points_round;

		const template_type = this.model.get( 'template_type' );
		const status = this.model.get( 'status' );

		if( status !== 'scheduled' ) {
			const models = template_type === 'overall' ?
				this.overallLadder.toJSON() :
				this.leagueTeams.toJSON();

			const new_models = this.historical_collection.concat(models);

			this.collection.reset(
				new_models,
				{ silent: true }
			);

			this.historical_collection = this.collection.toJSON();

		}

		return this;
	}

	updateModel() {
		this.model
			.set('rounds_collection', this.rounds)
			.setFixtureList()
			.checkIsPossibleLeave();

		return this;
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		let data = {
			league_id: this.league_id,
			offset:    this.offset,
			limit:     this.limit,
		};

		if(this.selected_round) {
			data = { ...data, round: this.selected_round };
		}

		return Promise.all( [
			this.rounds.fetch(),
			this.leagueTeams
				.showLeagueOnlyLadder( data ),
			this.overallLadder
				.showLeagueOverallLadder( data )
		] );
	}

	async showMore() {
		this.offset += this.default_offset;
		this.limit += this.default_limit;
		await this.fetchData();
		this.updatePageData();

		return this;
	}

	async switchTable() {
		Preloader.show();
		this.offset = 0;
		this.limit = this.default_limit;
		this.historical_collection = [];
		await this.fetchData();
		this.updatePageData();
	}

	async updatePageDataRound(round) {
		Preloader.show();
		this.selected_round = round;
		this.offset = 0;
		this.limit = this.default_limit;
		await this.fetchData();
		this.updateModel();

		const
			template_type = this.model.get( 'template_type' ),
			new_collection     = template_type === 'overall' ?
				this.overallLadder.toJSON() : this.leagueTeams.toJSON();

		this.collection.reset(
			new_collection,
			{ silent: true }
		);
		this.historical_collection = this.collection.toJSON();
		this.render();
		Preloader.hide();
	}

	updatePageData() {
		this.updateCollection()
			.isShowMoreButton()
			.render();

		Preloader.hide();
	}
}

export default CoreLeagueLadderView;